/**
 * Gestion des liste déroulantes avec une case à cocher
 */
(function ($) {   

$.fn.CustomDropdown = function(initValues) {

        $(this).each(function() {

        /**
         * Toggle dropdown visible state.
         * @param  {object} $element JQuery Object
         */
         function toggleDropdown($element) {
            var p = $element.closest($this);
            $element.closest($this).toggleClass('visible');
            if (!$this.hasClass('visible') && $dropdownValue.val() === '') {
                $this.find('input[type=checkbox]').each(function () {
                    if (!$(this).hasClass('valid')) {                   
                            $(this).prop("checked", false);                   
                    }
                });
            }          
        }

        /**
         * Affiche la liste des checkbox selectionné
         */
        function changeText() {
            var textArr = [];

            if (items.filter(':checked').length > 0) {
                // Des checkbox de coché
                items.filter(':checked').each(function () {
                    var activeItem = $(this).parent().find('label');
                    textArr.push(' ' + activeItem.text());
                });
                $dropdownPlaceholder.text(textArr);
                $dropdownValue.val(textArr); 
                $this.addClass('hasvalue');
            } else {
                // Pas de valeur
                textArr = [];
                $dropdownPlaceholder.text(defaultText);
                $dropdownValue.val(defaultText);                
                $this.removeClass('hasvalue');
            }
        }   
        
        var $this = $(this);
        var $dropdownValue = $this.find('.dropdown__value');
        var $dropdownToggle = $this.find('.dropdown__toggle'); // .dropdown__toggle
        var $dropdownList = $this.find('.dropdown__items-content ul'); // .list-checkboxes
        var $dropdownPlaceholder = $this.find('.dropdown__placeholder');
        var items = $dropdownList.find('input[type="checkbox"]');        

        var defaultText = $dropdownPlaceholder.text();

        // Clic sur le dropdown
        $dropdownToggle.on('click', function (event) {
            event.preventDefault();
            
            toggleDropdown($(this));
            changeText();

        });

        //Initialisation des valeurs
        if (initValues) {
        initValues.forEach(value => {
            jQuery('#field-'+value+'[name=subjects]').prop('checked', true);
        });
          //  $this.closest('.form__controls').addClass('animate-label');
            changeText();    
        }
        
        //Recalcul du texte sur un clic d'une checkbox
        items.each( function() {
            $(this).on('change', function (event) {
                changeText();
            });
        });
       
        //Referme le dropdown sur une clic externe au dropdown
        $(document).on('click',function(e) {
            if ($(e.target).closest('.js-custom-dropdown').length==0) {
                // Clic externe
                $this.removeClass('visible');                
            }
            else if($(e.target).closest('.js-custom-dropdown')[0] !== $this[0]) {
                //clic externe mais dans un autre .js-custom-dropdown
                $this.removeClass('visible');                
            }
            else if ($(e.target).closest('.dropdown__items-actions').length>0) {
                //Clic sur un bouton d'action contenu dans le dropdown  (Flitre par niveaux)
                $this.removeClass('visible');
            }
        })

    });
                 
}
})(jQuery);